export const ALL_SHERIFF_TYPES = [
  "HivedVan",
  "HivedHgv",
  "HivedFlex",
  "TakeHomeVan",
  "Dsp",
  "Trial",
  "Internal",
  "AssociateDriver",
] as const

export type SheriffType = (typeof ALL_SHERIFF_TYPES)[number]

export const OVERVIEW_SHERIFF_TYPES = ["HivedVan", "TakeHomeVan", "AssociateDriver"] as const
